class ComponentProductDetails extends Theme.Component {
  connectedCallback() {
    this.events();
  }

  switchTab(_, element) {
    const button = element;
    const target = button.getAttribute('data-tab');
    const tabButtons = this.querySelectorAll('.product-tabs-tab');
    const tabContents = this.querySelectorAll('.product-tabs-content');

    tabButtons.forEach(btn => btn.classList.remove('is-active'));
    tabContents.forEach(content => content.classList.remove('is-active'));

    button.classList.add('is-active');
    tabContents.forEach(content => {
      if (content.getAttribute('data-tab-content') === target) {
        content.classList.add('is-active');
      }
    });
  }
}

customElements.define('component-product-details', ComponentProductDetails);